import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Chinese Resident Identity Card validator following Single Responsibility Principle
 */
export class CnValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Chinese Resident Identity Card',
      pattern: /^\d{17}[\dX]$/i,
      length: 18
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'Chinese ID must be 17 digits followed by a digit or X'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const checksums = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += parseInt(upperCaseId[i]) * weights[i];
    }

    const expectedChecksum = checksums[sum % 11];
    const actualChecksum = upperCaseId[17];

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid Chinese ID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Chinese ID');
  }
}